// extracted by mini-css-extract-plugin
export default {"disableLink":"co-z"};